<div class="ws-accent-card ws-accent-card--navy">
    <div class="ws-accent-card__head">
        <h3 class="ws-accent-card__title">Adherence</h3>
    </div>
    <div class="ring-row">
        <div class="ring-stat">
            <div class="ring" [style.--pct]="ringPercent(disabled ? null : chapterAdherence)">{{ formatPercent(disabled ? null : chapterAdherence) }}</div>
            <div class="ring-stat__label">Chapters</div>
        </div>
        <div class="ring-stat">
            <div class="ring" [style.--pct]="ringPercent(disabled ? null : checkinAdherence)">{{ formatPercent(disabled ? null : checkinAdherence) }}</div>
            <div class="ring-stat__label">Check-ins</div>
        </div>
        <div class="ring-stat" *ngIf="type === 'patient'">
            <div class="ring" [style.--pct]="ringPercent(disabled ? null : foodDiaryCompletion)">{{ formatPercent(disabled ? null : foodDiaryCompletion) }}</div>
            <div class="ring-stat__label">Food Diary</div>
        </div>
    </div>
</div>
